import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./asd.css";
import { Icon } from "leaflet";
export default function Map(props) {
    return (
        <div>
            <br></br>
            <br></br>
            <br></br>
            <MapContainer
                center={props.center}
                zoom={13}
                scrollWheelZoom={false}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker
                    position={props.center}
                    icon={
                        new Icon({
                            iconUrl: require("../assets/img/loc.png"),
                            iconSize: [32, 32],
                            iconAnchor: [16, 32],
                        })
                    }
                >
                </Marker>
            </MapContainer>
        </div>
    );
}
